/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesViewType } from './WebApiModelsEnumerationTypesViewType';
import {
    WebApiModelsEnumerationTypesViewTypeFromJSON,
    WebApiModelsEnumerationTypesViewTypeFromJSONTyped,
    WebApiModelsEnumerationTypesViewTypeToJSON,
} from './WebApiModelsEnumerationTypesViewType';
import type { WebApiViewDtoUpdateViewColumnDto } from './WebApiViewDtoUpdateViewColumnDto';
import {
    WebApiViewDtoUpdateViewColumnDtoFromJSON,
    WebApiViewDtoUpdateViewColumnDtoFromJSONTyped,
    WebApiViewDtoUpdateViewColumnDtoToJSON,
} from './WebApiViewDtoUpdateViewColumnDto';

/**
 * 
 * @export
 * @interface WebApiViewDtoUpdateViewDto
 */
export interface WebApiViewDtoUpdateViewDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiViewDtoUpdateViewDto
     */
    name: string;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesViewType}
     * @memberof WebApiViewDtoUpdateViewDto
     */
    viewType: WebApiModelsEnumerationTypesViewType;
    /**
     * 
     * @type {number}
     * @memberof WebApiViewDtoUpdateViewDto
     */
    customListId?: number | null;
    /**
     * 
     * @type {Array<WebApiViewDtoUpdateViewColumnDto>}
     * @memberof WebApiViewDtoUpdateViewDto
     */
    viewColumns?: Array<WebApiViewDtoUpdateViewColumnDto> | null;
}

/**
 * Check if a given object implements the WebApiViewDtoUpdateViewDto interface.
 */
export function instanceOfWebApiViewDtoUpdateViewDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "viewType" in value;

    return isInstance;
}

export function WebApiViewDtoUpdateViewDtoFromJSON(json: any): WebApiViewDtoUpdateViewDto {
    return WebApiViewDtoUpdateViewDtoFromJSONTyped(json, false);
}

export function WebApiViewDtoUpdateViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiViewDtoUpdateViewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'viewType': WebApiModelsEnumerationTypesViewTypeFromJSON(json['viewType']),
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'viewColumns': !exists(json, 'viewColumns') ? undefined : (json['viewColumns'] === null ? null : (json['viewColumns'] as Array<any>).map(WebApiViewDtoUpdateViewColumnDtoFromJSON)),
    };
}

export function WebApiViewDtoUpdateViewDtoToJSON(value?: WebApiViewDtoUpdateViewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'viewType': WebApiModelsEnumerationTypesViewTypeToJSON(value.viewType),
        'customListId': value.customListId,
        'viewColumns': value.viewColumns === undefined ? undefined : (value.viewColumns === null ? null : (value.viewColumns as Array<any>).map(WebApiViewDtoUpdateViewColumnDtoToJSON)),
    };
}

